// react
import { ChangeEvent, useMemo } from 'react';

// types
import { EntityPayload, UserPayload } from '../../../../@types';

// i18n
import { useTranslation } from 'react-i18next';

// ui
import { Table, TableProps } from '../../../ui/Table/Table';

// headers
import { getHeaders } from './TableBasicUsersOnboard.headers';

// props
export interface TableBasicUsersOnboardProps extends Omit<TableProps, 'data' | 'headers'> {
	data: UserPayload[];
	entity: EntityPayload;
	isChecked?: boolean;
	isDisabled?: boolean;
	onChangeAllUsers?: (entity: EntityPayload, checked: boolean) => void;
	onChangeUser?: (
		e: ChangeEvent<HTMLInputElement>,
		checked: boolean,
		user: UserPayload,
		entity: EntityPayload
	) => void;
	selectedUserIds?: Set<string>;
}

export const TableBasicUsersOnboard = ({
	data = [],
	entity,
	isChecked,
	isDisabled,
	onChangeAllUsers,
	onChangeUser,
	selectedUserIds,
	...props
}: TableBasicUsersOnboardProps) => {
	// hooks
	const { t } = useTranslation();

	// vars
	const dataSorted = useMemo(
		() =>
			[...data].sort((a, b) => {
				const aName = `${a.firstName}${a.lastName}${a.idWbg}`.replaceAll(' ', '').toLowerCase();
				const bName = `${b.firstName}${b.lastName}${b.idWbg}`.replaceAll(' ', '').toLowerCase();
				return aName > bName ? 1 : -1;
			}),
		[data]
	);

	const headers = useMemo(
		() =>
			getHeaders({
				entity,
				isDisabled,
				isChecked,
				onChangeAllUsers,
				onChangeUser,
				selectedUserIds,
				t,
				users: data,
			}),
		[data, entity, isChecked, isDisabled, onChangeAllUsers, onChangeUser, selectedUserIds, t]
	);

	return <Table {...props} data={dataSorted} headers={headers} />;
};
